import React, { useState } from "react";
import { createHead, UnheadProvider } from "@unhead/react/client";
import { useBrowserNavigation } from "../hooks/useBrowserNavigation";

type HeadProviderProps = {
    children: React.ReactNode;
};

export const HeadProvider: React.FC<HeadProviderProps> = ({ children }) => {
    useBrowserNavigation();

    // Each render tree gets its own head instance.
    // During SSG (renderToString is synchronous), we store it on globalThis
    // so onSSRAppRendered can extract the tags after the render completes.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const [head] = useState(() => {
        const h = createHead();
        if (typeof window === "undefined") {
            (globalThis as Record<string, unknown>).__LAST_SSR_HEAD__ = h;
        }
        return h;
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return <UnheadProvider head={head}>{children}</UnheadProvider>;
};
